import { getScoreBg, scoreBand } from '../lib/score';

/**
 * The w-24 h-24 score badge shown on results and summary screens. Shared by
 * Manual and Automatic so the look lives in one place.
 *
 * Effects per band (Leanne, 22 Oct 2026):
 *   100        gold: pops in, glows, a shine sweeps across, sparkles, bounces
 *   80 to 99   emerald with a mint accent and mint shine, bounces
 *   60 to 79   soft green with a light ring, bounces
 *   40 to 59   amber with a light ring, bounces
 *   under 40   red with a light ring, stays still
 *
 * `score` is the raw score used for the background colour; `value` is the number
 * actually displayed (defaults to the rounded score). `suffix` appends e.g. '%'.
 */
const RING = {
    green: 'ring-[3px] ring-emerald-200 score-shine score-shine-mint',
    soft: 'ring-[3px] ring-green-200',
    amber: 'ring-[3px] ring-amber-200',
    rose: 'ring-[3px] ring-rose-200',
};
const SPARKS = [
    { style: { top: -6, left: 4, fontSize: 16, animationDelay: '.7s' } },
    { style: { top: 4, right: -2, fontSize: 12, animationDelay: '1.1s' } },
    { style: { top: 70, left: -4, fontSize: 11, animationDelay: '1.5s' } },
    { style: { top: 64, right: 2, fontSize: 16, animationDelay: '.9s' } },
];

export default function ScoreCircle({ score, value = Math.round(score), suffix = '' }) {
    const perfect = value === 100;
    const band = scoreBand(score);
    const effects = perfect ? 'score-perfect score-shine' : (RING[band] || '');
    const bounce = band !== 'rose' || perfect;
    return (
        <span className="relative inline-block mb-4">
            {perfect && SPARKS.map((s, i) => (
                <span key={i} aria-hidden="true" className="score-spark" style={s.style}>✦</span>
            ))}
            <span className={`inline-block ${bounce ? 'animate-bounce-subtle' : ''}`}>
                <span className={`inline-flex items-center justify-center w-24 h-24 rounded-full ${getScoreBg(score)} ${effects}`}>
                    <span className="relative z-[1] text-3xl font-bold text-white">{value}{suffix}</span>
                </span>
            </span>
        </span>
    );
}
